import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCurrentUser } from "../hooks/useCurrentUser";

export function StaffOnly(props: PropsWithChildren<unknown>) {
  const { isCustomer, isStaff, user } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isCustomer) {
      navigate(`/o/${user?.UserTenant[0]?.tenantId}`);
    }
  }, [isCustomer, navigate, user?.UserTenant]);

  if (!isStaff) {
    return <></>;
  }

  return <>{props.children}</>;
}
